import { JsonSchemaEnum } from '@evidentid/json-schema/interfaces/JsonSchema';

/** Human-readable text for an enum value, e.g. a credential type UUID rendered as its full name. */
export function getEnumLabel(schema: JsonSchemaEnum, value: unknown): string {
    const index = (schema.enum || []).indexOf(value);
    return (index === -1 ? null : schema.enumLabels?.[index]) || String(value);
}

/**
 * Turns CSV cell text back into the enum value it names.
 *
 * Text that is already an enum value passes straight through. Otherwise it must match exactly one
 * label: labels are not unique across the credential taxonomy, so a label shared by several values
 * is returned unresolved on purpose, which fails schema validation and sends the row to the
 * correction table for the user to disambiguate.
 */
export function resolveEnumValue(schema: JsonSchemaEnum, text: string): string {
    const trimmed = text.trim();
    const values = schema.enum || [];
    if (values.includes(trimmed)) {
        return trimmed;
    }
    const labels = schema.enumLabels;
    if (!labels) {
        return trimmed;
    }
    const matches = labels.reduce(
        (accu, label, index) => (label === trimmed ? [ ...accu, index ] : accu),
        [] as number[],
    );
    return matches.length === 1 ? values[matches[0]] : trimmed;
}
